export const moduleRoutes = {
  root: 'txns',
  childForms: {
    withdrawal: {
      data: { title: 'Retiros' },
      requireAuth: true,
      functions: [],
      route: 'withdrawal',
    },
    referencedWithdrawal: {
      data: { title: 'Retiros' },
      requireAuth: true,
      functions: [],
      route: 'referencedWithdrawal',
    },
    deposit: {
      data: { title: 'Consignaciones' },
      requireAuth: true,
      functions: [],
      route: 'deposit',
    },
    obligationPayment: {
      data: { title: 'Pago Obligaciones' },
      requireAuth: true,
      functions: [],
      route: 'obligacion',
    },
    transfer: {
      data: { title: 'Transferencias' },
      requireAuth: true,
      functions: [],
      route: 'transfer',
    },
    collection: {
      data: { title: 'Recaudos' },
      requireAuth: true,
      functions: [],
      route: 'collection',
    },
    barcodeCollection: {
      data: { title: 'Recaudos Código de Barras' },
      requireAuth: true,
      functions: [],
      route: 'recaudobarras',
    },
    creditCardCollection: {
      data: { title: 'Pago Tarjeta Crédito' },
      requireAuth: true,
      functions: [],
      route: 'cardcollection',
    },
    thirdPartyCollection: {
      data: { title: 'Recaudo de terceros' },
      requireAuth: true,
      functions: [],
      route: 'thirdcollection',
    },
    transactionStore: {
      data: { title: 'Transacciones' },
      requireAuth: true,
      functions: [],
      route: 'transactionStore',
    },
    // Card Admin
    cardActivation: {
      data: { title: 'Activación Tarjeta' },
      requireAuth: true,
      functions: [],
      route: 'activar',
    },
    cardChannelActivation: {
      data: { title: 'Activación Tarjeta por Canal' },
      requireAuth: true,
      functions: [],
      route: 'activarcanal',
    },
    cardReactivation: {
      data: { title: 'Reactivación Tarjeta' },
      requireAuth: true,
      functions: [],
      route: 'reactivas',
    },
    cardPinChange: {
      data: { title: 'Cambio de PIN' },
      requireAuth: true,
      functions: [],
      route: 'cambioclave',
    },
    // Credit Card
    creditCardAdvance: {
      data: { title: 'Avance Tarjeta de crédito' },
      requireAuth: true,
      functions: [],
      route: 'advance',
    },
    creditCardPayment: {
      data: { title: 'Pago Tarjeta de crédito' },
      requireAuth: true,
      functions: [],
      route: 'payment',
    },
    creditCardQuota: {
      data: { title: 'Cupo Tarjeta de crédito' },
      requireAuth: true,
      functions: [],
      route: 'cupo',
    },
    // Aprobaciones
    approvedTransactionList: {
      data: { title: 'Transacciones aprobadas' },
      requireAuth: true,
      functions: [],
      route: 'approved',
    },
    rejectedTransactionList: {
      data: { title: 'Transacciones rechazadas' },
      requireAuth: true,
      functions: [],
      route: 'rejected',
    },
    pendingTransactionList: {
      data: { title: 'Transacciones pendientes de aprobación' },
      requireAuth: true,
      functions: [],
      route: 'pending',
    },
  },
  layout: 'main',
  loadChildren: () => import('src/app/pages/transactions/transaction.module').then(m => m.TransactionsModule),
};
